// Custom components
import ConfigSummary from '../../components/ConfigSummary';
import { VerifyFeatureAccess } from 'components/UpSellModal/VerifyFeatureAccess';

// MUI
import { Stack } from '@mui/material';

// Utils
import { useWorkspaceHook } from 'utils/CustomHooks/useWorkspaceHook';
import { useCustomPermission } from 'utils/CustomHooks/useCustomPermission';

// Icons
import RequestsIcon from 'components/Icons/sidebarIcons/requestsIcon';
import LocationIcon from 'components/Icons/locationIcon';

const MainView = () => {
  const { navigateWithWorkspaceUrl } = useWorkspaceHook();
  const { hasFeature, FEATURES } = useCustomPermission();

  const handleClickConfig = (configType: 'publicRequests' | 'locations') => {
    switch (configType) {
      case 'publicRequests':
        navigateWithWorkspaceUrl('/configurations/public-requests');
        return;
      case 'locations':
        navigateWithWorkspaceUrl('/configurations/location-config');
        return;
      default:
        break;
    }
  };

  return (
    <Stack padding={'24px 60px'} gap={'16px'}>
      <VerifyFeatureAccess featureId={FEATURES.PUBLIC_WORK_ORDER_REQUEST}>
        <ConfigSummary
          icon={<RequestsIcon />}
          featureLocked={!hasFeature(FEATURES.PUBLIC_WORK_ORDER_REQUEST)}
          onClick={() => handleClickConfig('publicRequests')}
          configName="Public Work Request Portal"
          description={
            <span>
              Configure your publicly shareable request portal and customize
              fields available within the work request form.
              <a
                style={{
                  fontWeight: 700,
                  fontSize: 13,
                  marginLeft: '2px',
                }}
                href={
                  'https://help.xenia.team/hc/en-us/categories/15486235456667-Work-Requests'
                }
                target="_blank"
              >
                Learn More
              </a>
            </span>
          }
        />
      </VerifyFeatureAccess>
      <VerifyFeatureAccess
        featureId={FEATURES.ADVANCED_LOCATION_BASED_ASSIGNMENT}
      >
        <ConfigSummary
          featureLocked={
            !hasFeature(FEATURES.ADVANCED_LOCATION_BASED_ASSIGNMENT)
          }
          icon={
            <LocationIcon
              secondary={'rgba(66, 66, 66, 1)'}
              style={{
                path: {
                  strokeOpacity: 1,
                },
              }}
            />
          }
          onClick={() => handleClickConfig('locations')}
          configName="Advanced Location/Site Logic"
          description="Enable advanced location logic and assignment to manage multiple sites with user based access and create site hierarchies."
        />
      </VerifyFeatureAccess>
    </Stack>
  );
};

export default MainView;
